import { default as React, FunctionComponent, useState } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import OrderDetails from './OrderDetails'

const Order: FunctionComponent = () => {
  const { id } = useParams()
  const orderId = Number(id)
  const [order, setOrder] = useState<number | undefined>(1)

  if (!order) return <Navigate to="/orders" replace />

  return <OrderDetails orderId={orderId} onClose={() => setOrder(undefined)} />
}

export default React.memo(Order)
